import { useTranslation } from 'react-i18next';

import { cn } from 'src/common/utils';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
] as const;

type Props = {
  className?: string;
  'aria-label'?: string;
};

export const LanguageSelector = ({
  className,
  'aria-label': ariaLabel,
}: Props) => {
  const { i18n } = useTranslation();
  const currentLanguage =
    i18n.resolvedLanguage?.slice(0, 2) ?? i18n.language.slice(0, 2);

  return (
    <div
      className={cn('flex items-center gap-1 text-sm', className)}
      role="group"
      aria-label={ariaLabel}
    >
      {LANGUAGES.map(({ code, label }, index) => (
        <span key={code} className="flex items-center gap-1">
          {index > 0 ? (
            <span aria-hidden className="text-shuttleGray-400">
              |
            </span>
          ) : null}
          <button
            type="button"
            onClick={() => i18n.changeLanguage(code)}
            className={cn(
              'px-1 py-0.5',
              currentLanguage === code
                ? 'font-semibold text-white'
                : 'text-white/70 hover:text-white',
            )}
            aria-current={currentLanguage === code ? 'true' : undefined}
          >
            {label}
          </button>
        </span>
      ))}
    </div>
  );
};
